var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-emoji-picker',{attrs:{"i18n":_vm.i18n,"emoji-size":"32","emojisByRow":"5","id":"emojiPicker","showSearch":false},on:{"select":_vm.selectEmoji}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }